"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankDetailsDto = void 0;
class BankDetailsDto {
}
exports.BankDetailsDto = BankDetailsDto;
//# sourceMappingURL=bank-details.dto.js.map